export const GET_SPECIALTIES_REQUEST = "GET_SPECIALTIES_REQUEST";
export const GET_SPECIALTIES_SUCCESS = "GET_SPECIALTIES_SUCCESS";
export const GET_SPECIALTIES_FAIL    = "GET_SPECIALTIES_FAIL";